
import { defineComponent } from 'vue';

interface Petal {
  id: number;
  shape: string;
  style: Record<string, string>;
}

export default defineComponent({
  name: 'SakuraFall',
  setup() {
    // 移动端少飘一些花瓣，兼顾性能
    const count = (typeof window !== 'undefined' && window.innerWidth < 768) ? 10 : 18;
    const shapes = ['s1', 's2', 's3'];
    const petals: Petal[] = Array.from({ length: count }, (_, i) => {
      const size = 9 + Math.random() * 13;
      const fall = 9 + Math.random() * 11;   // 飘落时长
      const sway = 3 + Math.random() * 4;    // 左右摆动时长
      const delay = -Math.random() * 20;     // 负延迟让首屏即有花瓣
      return {
        id: i,
        shape: shapes[i % shapes.length],
        style: {
          left: (Math.random() * 100).toFixed(2) + 'vw',
          width: size.toFixed(1) + 'px',
          height: (size * 0.86).toFixed(1) + 'px',
          opacity: (0.5 + Math.random() * 0.45).toFixed(2),
          animationDuration: `${fall.toFixed(1)}s, ${sway.toFixed(1)}s`,
          animationDelay: `${delay.toFixed(1)}s, ${delay.toFixed(1)}s`
        }
      };
    });
    return { petals };
  }
});
